import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CommonButton from '../../CommonButton';
import { CommonButtonVariants } from '../../../../constants/CommonButtonVariants';
import placeBidIcon from '../../../../assets/img/place-bid-icon.png';
import SettingsSectionHeader from '../../../../settings/SettingsSectionHeader';

function SearchConfirmBidModal({ toggleShow, placeBid, bidAmount, vehicleTitle }) {
  const formatGBP = (amountInPence) => {
    const isNum = typeof amountInPence === 'number' && Number.isFinite(amountInPence);
    const pounds = isNum ? Math.round(amountInPence / 100) : 0;
    const grouped = pounds.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `£${grouped}`;
  };

  return (
    <Modal
      isOpen={true}
      backdrop="static"
      keyboard={false}
      zIndex={3001}
      size="lg"
      className="place-bid-modal"
      backdropClassName="place-bid-modal-backdrop"
    >
      <ModalBody>
        <ModalHeader toggle={toggleShow} tag="div">
          <SettingsSectionHeader header="Confirm your bid" variant="noBorder" />
        </ModalHeader>
        <p className="confirm-bid-review">Please review and confirm your bid:</p>
        <div className="confirm-bid-cols-wrapper">
          <div className="confirm-bid-col">
            <p className="confirm-bid-col-value">{formatGBP(bidAmount * 100)}</p>
            <p className="confirm-bid-col-text">YOUR BID</p>
          </div>
          <div className="confirm-bid-col">
            <p className="confirm-bid-col-vehicle">{vehicleTitle}</p>
            <p className="confirm-bid-col-text">VEHICLE</p>
          </div>
        </div>
        <div className="actions-wrapper">
          <CommonButton
            variant={CommonButtonVariants.RED}
            label="Place bid"
            type="submit"
            handleClick={placeBid}
            className="w-100"
            icon={placeBidIcon}
            iconAlt="Place Bid"
            iconLeft
          />
          <CommonButton
            variant={CommonButtonVariants.OUTLINED_RED}
            label="CANCEL"
            handleClick={toggleShow}
            className="w-100"
          />
        </div>
      </ModalBody>
    </Modal>
  );
}

export default SearchConfirmBidModal;
